import { render } from "./CalendarAddComponent.vue?vue&type=template&id=2df5a63c&scoped=true&ts=true"
import script from "./CalendarAddComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarAddComponent.vue?vue&type=script&lang=ts"

import "./CalendarAddComponent.vue?vue&type=style&index=0&id=2df5a63c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df5a63c"]])

export default __exports__